import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyZhTw() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隱私政策

「AI學習助手」（以下簡稱「本應用程式」）尊重使用者的隱私，並最大限度地注意保護個人資訊。本應用程式不收集使用者的個人資訊，並採取措施保護使用者的資料。本隱私政策（以下簡稱「本政策」）規定了本應用程式中資訊的處理方式。

## 第1條（個人資訊的收集和管理方針）

本應用程式不收集使用者的任何個人資訊（如姓名、地址、電話號碼、電子郵件地址等）。應用程式內的所有功能都是在不收集個人資訊的前提下設計的。此外，為了保護使用者的隱私，我們根據個人資訊保護法，不收集或儲存任何可以識別個人身份的資訊。

## 第2條（作業・考試題目的圖像和資料儲存）

在本應用程式中，使用者拍攝的作業和考試題目圖像、掃描的文件、手寫去除處理後的資料均僅儲存在使用者的裝置中，不會儲存在應用程式外部的伺服器上。因此，我們無法存取使用者拍攝和儲存的圖像和資料。我們還保證這些圖像資料不會提供給第三方，並將安全地儲存在使用者的裝置中。

## 第3條（AI題目解答功能）

本應用程式提供將使用者拍攝的題目圖像發送給AI以獲取解答的功能。使用此功能時，題目圖像會臨時發送到外部AI服務，但不包含個人身份識別資訊。發送的圖像在解答處理後會被刪除，不會長期保存。此外，AI服務提供商不會將這些圖像用於其他目的。此功能的使用是可選的，使用者可以隨時停止使用。

## 第4條（相機和照片庫存取）

本應用程式為提供作業和考試題目的拍攝及掃描功能，可能會請求存取使用者裝置的相機和照片庫權限。這些權限僅用於執行應用程式的基本功能，我們不會在未經許可的情況下存取使用者的照片或相機功能。此外，使用者可以隨時從裝置設定中更改或撤銷存取權限。

## 第5條（資料加密和安全）

本應用程式為保護使用者資料，對裝置內儲存的所有資料使用適當的加密技術。此外，為了最大限度地降低應用程式使用過程中可能出現的安全風險，我們會定期實施安全更新。但是，使用者裝置本身的安全需要使用者自行適當管理。

## 第6條（應用程式使用情況分析）

本應用程式為了改善服務，可能會在不能識別個人身份的範圍內分析應用程式的使用情況（功能使用頻率、錯誤發生情況等）。這些分析資料不包含個人資訊，僅收集統計資訊，並僅用於應用程式改進和新功能開發。

## 第7條（與第三方服務的整合）

本應用程式在AI題目解答功能中使用第三方AI服務。這些服務提供商各自擁有獨立的隱私政策，使用者資料的處理遵循各服務提供商的政策。本應用程式會最大限度地減少發送給這些第三方服務的資料，並確保不包含個人資訊。

## 第8條（使用者權利和資料管理）

本應用程式確保使用者可以完全管理自己的資料。使用者可以隨時刪除應用程式內的資料，除非使用者操作，否則本應用程式不會向外部發送資料（AI題目解答功能除外）。此外，根據使用條款，由於使用本應用程式時不使用個人資訊，因此不適用於資訊披露、更正、刪除或停止使用的請求。

## 第9條（對法律要求的回應）

由於本應用程式不收集個人資訊，通常情況下無法回應執法機構等的資訊披露要求。但是，如果有法律有效的搜查令或法院命令等，我們將根據法律法規適當回應。

## 第10條（隱私政策的變更）

本應用程式可能會不時審查本政策的內容，並根據法律修訂和應用程式功能的變更來改變本政策，以提高使用者隱私保護。當發生變更時，我們將通過在本應用程式內發布最新的隱私政策來通知使用者，並在發布的同時生效。請使用者定期查看本政策。

## 第11條（聯絡方式）

如果您對本政策有任何問題或疑慮，請通過以下地址與我們聯絡。如有隱私相關的問題或擔憂，請隨時聯絡我們。

電子郵件：linappworks@gmail.com

最終更新日期：2025年8月20日
  `;

  return (
    <Container>
      <Content>
        <Title>隱私政策</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyZhTw; 
